export { default as AbuseChRansomAdapterDocumentation } from './AbuseChRansomAdapterDocumentation';
export { default as AbuseChRansomAdapterFieldSet } from './AbuseChRansomAdapterFieldSet';
export { default as AbuseChRansomAdapterSummary } from './AbuseChRansomAdapterSummary';



// WEBPACK FOOTER //
// ./src/web/components/adapters/abusech/index.jsx